import StackDriverErrorReporter from "stackdriver-errors-js";
import { v4 as uuid } from "uuid";

export const cid = uuid();

let reporter = {
  report: console.error,
};

if (process.env.NODE_ENV === "production" && typeof window !== "undefined") {
  reporter = new StackDriverErrorReporter();

  reporter.start({
    key: process.env.GATSBY_GOOGLE_STACK_DRIVER_API_KEY,
    projectId: process.env.GATSBY_GOOGLE_STACK_DRIVER_PROJECT_ID,
    service: "de_lwebco_b2bfinance_apps_www",
    version: process.env.GATSBY_GOOGLE_STACK_DRIVER_SERVICE_VERSION || "master",
    reportUncaughtExceptions: false,
    context: {
      user: cid,
    },
  });
}

export const error = (name, message) => new Error(`[${name}] ${message}`);

export default reporter;
